/* eslint-disable vue/require-prop-types */
<template>
	<div class="ADTAndIPTDetails">
		<div class="section1">
			<div class="float-right">
				<img
					src="../../../../../assets/images/close-button.png"
					alt=""
					class="cursor-pointer"
					@click="redirectBackPage()"
				/>
			</div>
			<div class="card">
				<div>
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
							<div>
								<p class="text-sm py-2">Select Week</p>
								<el-date-picker
									v-model="select_week"
									type="week"
									style="width: 90%"
									placeholder="Pick a week"
									:format="customDateFormat"
									:picker-options="dateRangeOptions"
									@change="selectweekdate"
								>
								</el-date-picker>
							</div>
						</el-col>
					</el-row>
				</div>

				<div class="py-4">
					<div class="py-2">
						<el-row :gutter="15">
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<p class="text-center text-base font-semibold">Day</p>
							</el-col>
							<el-col :xs="8" :sm="8" :md="7" :lg="7" :xl="7">
								<p class="text-center mr-20 text-base font-semibold">
									Transaction
								</p>
							</el-col>
							<el-col :xs="8" :sm="8" :md="5" :lg="5" :xl="5">
								<p class="text-center mr-16 text-base font-semibold">IPT</p>
							</el-col>
						</el-row>
					</div>
					<div v-for="(item, index) in week_list" :key="index" class="py-2">
						<el-row :gutter="15">
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<p class="text-center pt-3 font-bold">
									{{ item.date | formatDate }}
									{{ new Date(item.date).getDate() }}
									{{ monthNames[new Date(item.date).getMonth()] }}
								</p>
								&nbsp;
							</el-col>
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<BaseInput
									v-model="item.adt"
									class="baseInput"
									style="width: 70%;"
									custom-class="p-2 text-sm  text-amp-input-boxes text-center"
								/>
							</el-col>
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<BaseInput
									v-model="item.ipt"
									class="baseInput"
									style="width: 70%;"
									custom-class="p-2 text-sm  text-amp-input-boxes text-center"
								/>
							</el-col>
							<el-col :xs="8" :sm="8" :md="6" :lg="5" :xl="5">
								<div class="buttons-parrent">
									<div class="button-child">
										<BaseButton
											type="submit"
											buttonclass="btn p-2.5 text-xs"
											class="w-32"
											@click="categoryAdtIpt(item.date)"
										>
											IPT Details
										</BaseButton>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
					<div class="py-2">
						<el-row :gutter="15">
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<p class="text-center font-bold">
									Average
								</p>
							</el-col>
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<p
									class="text-center font-normal text-xs pt-1"
									style="width: 70%;"
								>
									{{ scheduleSummary.projected_adt }}
								</p>
								<!-- <BaseInput
									v-model="scheduleSummary.projected_adt"
									class="baseInput"
									style="width: 70%;"
									custom-class="p-2 text-xs  text-amp-input-boxes text-center"
								/> -->
							</el-col>
							<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
								<p
									class="text-center font-normal text-xs pt-1"
									style="width: 70%;"
								>
									{{ scheduleSummary.ipt }}
								</p>
								<!-- <BaseInput
									v-model="scheduleSummary.ipt"
									class="baseInput"
									style="width: 70%;"
									custom-class="p-2 text-sm  text-amp-input-boxes text-center"
								/> -->
							</el-col>
						</el-row>
					</div>
					<div class="py-4">
						<el-row :gutter="15">
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<div class="buttons-parrent2">
									<div class="button-child">
										<BaseButton
											type="submit"
											buttonclass="btn  p-2.5 text-xs"
											class="w-24 ml-2"
											@click="updateAdtIpt()"
										>
											Update
										</BaseButton>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
				<!-- <div class="py-4">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
							<p class="font-schedile-lbl-17 pt-3">
								Average Daily Transaction (ADT)
							</p>
						</el-col>
						<el-col :xs="14" :sm="14" :md="7" :lg="7" :xl="7">
							<BaseInput
								v-model="scheduleSummary.projected_adt"
								class="baseInput"
								style="width: 100%;"
								disabled
								custom-class="p-2 text-sm  text-amp-input-boxes text-center"
							/>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="buttons-parrent">
								<div class="button-child">
									<BaseButton
										type="submit"
										class="w-32"
										buttonclass="btn p-2.5 text-xs"
										@click="editApi()"
									>
										View Day Wise
									</BaseButton>
								</div>
							</div>
						</el-col>
					</el-row>
				</div> -->
				<!-- <div class="py-4">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
							<p class="font-schedile-lbl-17 pt-3">Items Per Transaction</p>
						</el-col>
						<el-col :xs="14" :sm="14" :md="7" :lg="7" :xl="7">
							<BaseInput
								v-model="scheduleSummary.ipt"
								class="baseInput"
								style="width: 100%;"
								disabled
								custom-class="p-2 text-sm  text-amp-input-boxes text-center"
							/>
						</el-col>
					</el-row>
				</div> -->
				<!-- <div class="py-4">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
							<p class="text-sm pt-3">Total Labor Hours</p>
						</el-col>
						<el-col :xs="14" :sm="14" :md="7" :lg="7" :xl="7">
							<BaseInput
								v-model="scheduleSummary.projected_labour_hours"
								class="baseInput"
								style="width: 100%;"
								disabled
								custom-class="p-2 text-sm  text-amp-input-boxes text-center"
							/>
						</el-col>
					</el-row>
				</div>
				<div class="py-4">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
							<p class="text-sm pt-3">Total Manpower</p>
						</el-col>
						<el-col :xs="14" :sm="14" :md="7" :lg="7" :xl="7">
							<BaseInput
								v-model="scheduleSummary.projected_man_power"
								class="baseInput"
								style="width: 100%;"
								disabled
								custom-class="p-2 text-sm  text-amp-input-boxes text-center"
							/>
						</el-col>
					</el-row>
				</div> -->
				<!-- <div>
					<el-row>
						<el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">&nbsp;</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="buttons-parrent pt-5">
								<div class="button-child">
									<BaseButton
										type="submit"
										class="w-24"
										buttonclass="btn p-2.5 text-xs"
									>
										Ok
									</BaseButton>
								</div>
							</div>
						</el-col>
					</el-row>
				</div> -->
			</div>
		</div>
		<div>
			<el-dialog
				title="Projected Daywise"
				:visible.sync="edit_ADT_IPT_diaog"
				width="50%"
				:before-close="adtIptPopUphandleClose"
			>
				<div class="py-2">
					<el-row :gutter="15">
						<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
							<p class="text-center text-base font-semibold">Day</p>
						</el-col>
						<el-col :xs="8" :sm="8" :md="7" :lg="7" :xl="7">
							<p class="text-center mr-20 text-base font-semibold">
								Transaction
							</p>
						</el-col>
						<el-col :xs="8" :sm="8" :md="5" :lg="5" :xl="5">
							<p class="text-center mr-16 text-base font-semibold">IPT</p>
						</el-col>
					</el-row>
				</div>
				<div v-for="(item, index) in week_list" :key="index" class="py-2">
					<el-row :gutter="15">
						<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
							<p class="text-center pt-3 font-bold">
								{{ item.date | formatDate }}
								{{ new Date(item.date).getDate() }}
								{{ monthNames[new Date(item.date).getMonth()] }}
							</p>
							&nbsp;
						</el-col>
						<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
							<BaseInput
								v-model="item.adt"
								class="baseInput"
								style="width: 70%;"
								custom-class="p-2 text-sm  text-amp-input-boxes text-center"
							/>
						</el-col>
						<el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
							<BaseInput
								v-model="item.ipt"
								class="baseInput"
								style="width: 70%;"
								custom-class="p-2 text-sm  text-amp-input-boxes text-center"
							/>
						</el-col>
						<el-col :xs="8" :sm="8" :md="6" :lg="5" :xl="5">
							<div class="buttons-parrent">
								<div class="button-child">
									<BaseButton
										type="submit"
										buttonclass="btn p-2.5 text-xs"
										class="w-32"
										@click="categoryAdtIpt(item.date)"
									>
										IPT Details
									</BaseButton>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="py-4">
					<el-row :gutter="15">
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<div class="buttons-parrent2">
								<div class="button-child">
									<BaseButton
										type="submit"
										buttonclass="btn  p-2.5 text-xs"
										class="w-24 ml-2"
										@click="updateAdtIpt()"
									>
										Update
									</BaseButton>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-dialog>
		</div>
		<div>
			<el-dialog
				title="Category IPT"
				:visible.sync="category_IPT_diaog"
				width="50%"
				:before-close="categoryIptPopUphandleClose"
			>
				<div>
					<p class="mb-6 text-base font-bold">{{ currentDate }}</p>
				</div>
				<div class="py-2">
					<el-row :gutter="15">
						<el-col :xs="10" :sm="8" :md="10" :lg="13" :xl="13">
							<p class="text-center ml-16 text-base font-bold">Categories</p>
						</el-col>
						<el-col :xs="6" :sm="4" :md="2" :lg="2" :xl="2">
							<p class="text-center text-base  font-bold">IPT</p>
						</el-col>
					</el-row>
				</div>
				<div
					v-for="(category, index1) in category_list"
					:key="index1"
					class="py-2"
				>
					<el-row :gutter="20">
						<el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
						<el-col :xs="8" :sm="8" :md="7" :lg="7" :xl="7">
							<p class="text-center pt-3 font-bold">
								{{ category.category }}
							</p>
							&nbsp;
						</el-col>
						<el-col :xs="8" :sm="8" :md="12" :lg="12" :xl="12">
							<BaseInput
								v-model="category.ipts"
								class="baseInput"
								style="width: 50%;"
								custom-class="p-2 text-sm text-amp-input-boxes text-center"
							/>
						</el-col>
					</el-row>
				</div>
				<div class="py-4">
					<el-row :gutter="15">
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<div class="buttons-parrent2">
								<div class="button-child ml-10">
									<BaseButton
										type="submit"
										class="w-24"
										buttonclass="btn p-2.5 text-xs"
										@click="categoryUpdateIpt(hedingDate)"
									>
										Update
									</BaseButton>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import LabourPalnningService from "../../../../../services/labourPalnningService";
import moment from "moment";
export default {
	name: "ADTAndIPTDetails",
	filters: {
		formatDate(date) {
			return moment(date).format("ddd");
		}
	},
	props: {
		storeName: {
			type: String,
			default: () => ""
		},
		date: {
			type: String,
			default: () => ""
		},
		adtIptDialog: {
			type: String,
			default: () => ""
		}
	},
	data() {
		return {
			dateRangeOptions: {
				firstDayOfWeek: 1
			},
			edit_ADT_IPT_diaog: false,
			category_IPT_diaog: false,
			select_week: "",
			project_ADTs: "",
			project_IPTs: "",
			totle_labour_hours: "",
			Staff_reqiuired: "",
			customDateFormat: "",
			firstdays: "",
			lastdays: "",
			weekdetail_list: [],
			opens_all_day: false,
			Store_Closed_On_list: [],
			day: "",
			currentDate: "",
			hedingDate: "",
			scheduleSummary: {},
			category_list: [
				{
					category: "",
					ipts: ""
				},
				{
					category: "",
					ipts: ""
				},
				{
					category: "",
					ipts: ""
				},
				{
					category: "",
					ipts: ""
				}
			],
			week_list: [
				{
					date: "",
					Adt: "",
					Ipt: ""
				},
				{
					date: "",
					Adt: "",
					Ipt: ""
				},
				{
					date: "",
					Adt: "",
					Ipt: ""
				},
				{
					date: "",
					Adt: "",
					Ipt: ""
				},
				{
					date: "",
					Adt: "",
					Ipt: ""
				},
				{
					date: "",
					Adt: "",
					Ipt: ""
				},
				{
					date: "",
					Adt: "",
					Ipt: ""
				}
			],
			day_list: [
				{ id: 1, day: "Monday" },
				{ id: 2, day: "Tuesday" },
				{ id: 3, day: "Wednesday" },
				{ id: 4, day: "Thursday" },
				{ id: 5, day: "Friday" },
				{ id: 6, day: "Saturday" },
				{ id: 7, day: "Sunday" }
			],
			Weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
			monthNames: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"June",
				"July",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			]
			// first_time_insert_ipt: true
		};
	},
	// computed: {
	// 	displayStores() {
	// 		return this.weekdetail_list.map(location => {
	// 			return {
	// 				day: store_close_on,
	// 				account_info: this.weekdetail_list.find(weekdetail_list => {
	// 					if (weekdetail_list.id === weekdetail_list) return true;
	// 				})
	// 			};
	// 		});
	// 	}
	// },
	created() {
		this.selectweekdate();
		console.log("adtIptDialog", this.adtIptDialog);
		if (this.adtIptDialog) {
			this.edit_ADT_IPT_diaog = true;
		}
		// this.editApi();
	},
	methods: {
		updateWeekDetails() {
			var temp = [];
			for (var i in this.Store_Closed_On_list) {
				for (var j in this.day) {
					if (this.day[j] == this.Store_Closed_On_list[i].id) {
						temp.push(this.Store_Closed_On_list[i]);
					}
				}
			}
			var data = {
				start_date: this.firstdays,
				end_date: this.lastdays,
				outlet: this.storeName,
				opens_all_day: this.weekdetail_list.opens_all_day,
				store_close_on: temp
			};
			LabourPalnningService.updateWeekDetail(data).then(response => {
				// console.log(response);
			});
		},
		selectweekdate() {
			let week = [];
			let dateOfWeeks = [];
			let date = this.select_week
				? this.select_week
				: (this.select_week = new Date(this.date));
			var dt = new Date(date); // current date of week
			var currentWeekDay = dt.getDay();
			var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
			var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
			var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
			this.firstdays = moment(wkStart).format("YYYY-MM-DD");
			this.lastdays = moment(wkEnd).format("YYYY-MM-DD");

			this.customDateFormat = `${this.firstdays} To ${this.lastdays}`;

			this.shedulingPartnerSummary();
		},
		shedulingPartnerSummary() {
			var data = {
				start_date: this.firstdays,
				end_date: this.lastdays,
				view: "week",
				outlet: this.storeName
			};
			LabourPalnningService.shedulingPartnerSummaryNetworkCallBack(data).then(
				response => {
					this.scheduleSummary = JSON.parse(response.data);
				}
			);
			this.editApi();
		},
		getWeekOfDaysFromFirstDate(current) {
			var week = new Array();
			// Starting Monday not Sunday
			current.setDate(current.getDate() - current.getDay() + 1);
			for (var i = 0; i < 7; i++) {
				week.push(new Date(current));
				current.setDate(current.getDate() + 1);
			}
			return week;
		},
		editApi() {
			// this.edit_ADT_IPT_diaog = true;
			var data = {
				start_date: this.firstdays,
				end_date: this.lastdays,
				view: "daily",
				outlet: this.storeName
			};
			LabourPalnningService.readAdtIptWeekDay(data).then(response => {
				if (JSON.parse(response.data).length) {
					this.week_list = JSON.parse(response.data);
				} else {
					var currentSelectedWekDays = this.getWeekOfDaysFromFirstDate(
						new Date(this.firstdays)
					);
					this.week_list = [];
					for (var day in currentSelectedWekDays) {
						this.week_list.push({
							date: currentSelectedWekDays[day],
							adt: "",
							ipt: ""
						});
					}
				}
				// check for week list having all ipt is 0
				// if (!this.week_list.every(item => item.ipt === 0)) {
				// 	this.first_time_insert_ipt = false;
				// }
			});
		},
		upCommingWeekDetails() {
			var data = {
				start_date: this.firstdays,
				end_date: this.lastdays,
				outlet: this.storeName
			};
			LabourPalnningService.upcomingWeekDetails(data).then(response => {
				this.weekdetail_list = JSON.parse(response.data);
				for (var i in this.weekdetail_list.store_close_on) {
					this.day.push(this.weekdetail_list.store_close_on[i].id);
				}
				console.log("this.weekdetail_list", this.weekdetail_list);
			});
		},
		categoryAdtIpt(date) {
			this.category_IPT_diaog = true;
			this.hedingDate = date;
			this.currentDate = `${moment(date).format("Do MMM YYYY")}`;

			var data = {
				outlet: this.storeName,
				date: `${moment(date).format("YYYY-MM-DD")}`
			};
			LabourPalnningService.categoryAdtIptNetworkCallBack(data).then(
				response => {
					this.category_list = JSON.parse(response.data);
				}
			);
		},
		updateAdtIpt() {
			var temp = [];

			let days = [];
			for (var i = 0; i < this.week_list.length; i++) {
				days.push(this.week_list[i]);
			}
			var data = {
				outlet: this.storeName,
				days
			};
			LabourPalnningService.updateAdtIptNetworkCallBack(data).then(response => {
				if (response.status == 200) {
					this.edit_ADT_IPT_diaog = false;
					this.$notify.success({
						title: "Success",
						message: "Updated successfully"
					});
					this.shedulingPartnerSummary();
				}
			});
		},
		categoryUpdateIpt(hedingDate) {
			var temp = [];
			let category = [];
			for (var i = 0; i < this.category_list.length; i++) {
				category.push(this.category_list[i]);
			}
			var data = {
				outlet: this.storeName,
				categories: category,
				date: this.hedingDate
			};
			LabourPalnningService.updateCategoryIptNetworkCallBack(data).then(
				response => {
					if (response.status == 200) {
						this.category_IPT_diaog = false;
						this.$notify.success({
							title: "Success",
							message: "Updated successfully"
						});
						this.editApi();
					}
				}
			);
		},
		adtIptPopUphandleClose() {
			this.edit_ADT_IPT_diaog = false;
		},
		categoryIptPopUphandleClose() {
			this.category_IPT_diaog = false;
		},
		redirectBackPage() {
			this.$router.push({ name: "SchedulePlanner" }).catch(()=>{});
		}
		// changeIpt(ipt, week_index) {
		// 	if (this.first_time_insert_ipt && week_index === 0) {
		// 		this.week_list.forEach(week => {
		// 			week.ipt = ipt;
		// 		});
		// 		this.first_time_insert_ipt = false;
		// 	}
		// }
	}
};
</script>

<style lang="scss" scoped>
@import "./ADTAndIPTDetails.scss";
</style>
<style>
input:disabled {
	background: #fff;
}
.ADTAndIPTDetails .el-input__inner {
	text-transform: capitalize;
}
.ADTAndIPTDetails .el-dialog__title {
	text-transform: capitalize;
	color: #ffffff;
}
.ADTAndIPTDetails .el-dialog__header {
	background: #2e323a;
	color: #ffffff;
	padding: 15px;
}
.ADTAndIPTDetails .el-dialog__headerbtn .el-dialog__close:hover {
	color: #ffffff;
}
.ADTAndIPTDetails .el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close:hover {
	color: #ffffff;
}
</style>
